import { colors } from '@insurancemenu/imenu-components-lib';
import { createUseStyles } from 'react-jss';

const styles = {
  dropdownButton: {
    fontWeight: 700,
    width: '10rem',
  },
  dropdownOpenedBtn: {
    backgroundColor: 'transparent',
    color: colors.blue[600],
    border: 'none',
    boxShadow: 'none',
    width: '10rem',
  },
};

const createStyles = createUseStyles(styles);

export { createStyles };
